/* 🤖 this file was generated by svg-to-ts */
export const siriusCopy: {
  name: 'copy';
  data: string;
} = {
  name: 'copy',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style="display: block;"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.25 3a.75.75 0 0 0-.75.75V7.5H3.75a.75.75 0 0 0-.75.75v12c0 .414.336.75.75.75h12a.75.75 0 0 0 .75-.75V16.5h3.75a.75.75 0 0 0 .75-.75v-12a.75.75 0 0 0-.75-.75h-12Zm8.25 12h3V4.5H9v3h6.75a.75.75 0 0 1 .75.75V15Zm-12-6v10.5H15V9H4.5Z" fill="currentColor"/></svg>`
};
